import { useLocation } from "react-router-dom";
import { Breadcrumbs } from "../../CommonElements";
import DaftarCuti from "../../Component/Cuti/containers/DaftarCuti";
import PageContainer from "../../Layout/Containers/PageContainer";

const DaftarCutiPage = () => {
  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const type = parameters.get("type");

  return (
    <PageContainer
      breadcrumbs={
        <Breadcrumbs
          parent="Cuti"
          title={
            type === "rekap"
              ? "Rekap Cuti"
              : type === "proses"
              ? "Daftar Dalam Proses Cuti"
              : "Daftar Cuti Disetujui"
          }
        />
      }
    >
      <DaftarCuti />
    </PageContainer>
  );
};

export default DaftarCutiPage;
